// stores/layout.js
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useLayoutStore = defineStore('layout', () => {
  // localStorage에서 저장된 값을 가져오거나, 없으면 'sidebar' 사용
  const layoutMode = ref(localStorage.getItem('layoutMode') || 'top');
  //const layoutMode = ref(localStorage.getItem("layoutMode") || "sidebar");
  // localStorage에서 useTabView 값을 가져옴
  const savedTabView = localStorage.getItem('useTabView');
  const useTabView = ref(
    savedTabView === null ? false : savedTabView === 'true',
  );
  // Breadcrumb 표시 여부 true일때만 true null 이면 false
  //const showBreadcrumb = ref(localStorage.getItem('showBreadcrumb') === 'true');
  //false가 아닐때 true null이나 true일때 true
  const showBreadcrumb = ref(
    localStorage.getItem('showBreadcrumb') !== 'false',
  );
  // 채팅 사용 여부 상태 추가 - 환경 변수와 localStorage 연동
  const useChat = ref(
    localStorage.getItem('useChat') !== 'false' && (import.meta.env.VITE_USE_CHAT !== 'false')
  );
  // 전체화면 모드 상태 추가
  const isFullScreen = ref(localStorage.getItem('isFullScreen') === 'true');

  const setLayoutMode = (mode) => {
    console.log('Setting layout mode to:', mode);
    layoutMode.value = mode;
    // localStorage에 현재 모드 저장
    localStorage.setItem('layoutMode', mode);
  };
  const toggleTabView = () => {
    useTabView.value = !useTabView.value;
    localStorage.setItem('useTabView', useTabView.value);
  };
  // Breadcrumb 토글 함수 추가
  const toggleBreadcrumb = () => {
    showBreadcrumb.value = !showBreadcrumb.value;
    localStorage.setItem('showBreadcrumb', showBreadcrumb.value);
  };
  // 채팅 토글 함수 추가
  const toggleChat = () => {
    useChat.value = !useChat.value;
    localStorage.setItem('useChat', useChat.value);
  };
  // 전체화면 모드 관련 함수 추가
  const setFullScreen = (value) => {
    isFullScreen.value = value;
    localStorage.setItem('isFullScreen', value);
  };

  const toggleFullScreen = () => {
    isFullScreen.value = !isFullScreen.value;
    localStorage.setItem('isFullScreen', isFullScreen.value);
  };
  return {
    layoutMode,
    setLayoutMode,
    useTabView,
    toggleTabView,
    showBreadcrumb,
    toggleBreadcrumb,
    useChat, // 채팅 사용 여부 상태 export
    toggleChat, // 채팅 토글 함수 export
    // 전체화면 모드 관련 상태와 함수들 export
    isFullScreen,
    setFullScreen,
    toggleFullScreen,
  };
});
